function isHoneylove() {
  const href = window.location.href;
  return (href || '').toLowerCase().indexOf('honeylove') !== -1;
}

export default isHoneylove;
